function slideUp(el, duration) {
  duration = duration || 300;
  el.style.transitionProperty = 'height, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.height = el.offsetHeight + 'px';
  el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = '0';
  el.style.paddingTop = '0';
  el.style.paddingBottom = '0';
  setTimeout(function() {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-property');
    el.style.removeProperty('transition-duration');
  }, duration);
}

function slideDown(el, duration) {
  duration = duration || 300;
  el.style.removeProperty('display');
  var display = window.getComputedStyle(el).display;
  if (display === 'none') display = 'block';
  el.style.display = display;
  var height = el.scrollHeight;
  el.style.overflow = 'hidden';
  el.style.height = '0';
  el.style.paddingTop = '0';
  el.style.paddingBottom = '0';
  el.offsetHeight;
  el.style.transitionProperty = 'height, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  setTimeout(function() {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-property');
    el.style.removeProperty('transition-duration');
  }, duration);
}

function slideToggle(el, duration) {
  if (window.getComputedStyle(el).display === 'none') {
    slideDown(el, duration);
  } else {
    slideUp(el, duration);
  }
}

function backToTop() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}
const toggleSearchDrawerBtn = document.getElementById('toggleSearchDrawer');
const searchInputWrapper = document.getElementById('SearchInputWrapper');
const searchDrawer = document.getElementById('SearchDrawer');
const closeSearchDrawerBtn = document.getElementById('closeSearchDrawer');
let isSearchInputOpen = false; // Track the state of the search input

if (toggleSearchDrawerBtn) {
  toggleSearchDrawerBtn.addEventListener('click', function(event) {
    event.stopPropagation(); // Prevent click from propagating

    if (window.innerWidth >= 768) {
      // For screens wider than 768px, toggle the search input slide
      if (!isSearchInputOpen) {
        searchInputWrapper.classList.remove('hidden');
        setTimeout(() => {
          searchInputWrapper.classList.add('open');
        }, 10);
        isSearchInputOpen = true;
      } else {
        searchInputWrapper.classList.remove('open');
        setTimeout(() => {
          searchInputWrapper.classList.add('hidden');
        }, 300); // Match the transition duration
        isSearchInputOpen = false;
      }
    } else {
      // For smaller screens, toggle the drawer (original functionality)
      if (searchDrawer) {
        searchDrawer.classList.toggle('hidden');
      }
    }
  });
}

// For closing the search drawer on smaller screens (original functionality)
if (closeSearchDrawerBtn) {
  closeSearchDrawerBtn.addEventListener('click', function(event) {
    event.stopPropagation(); // Prevent click from propagating
    if (window.innerWidth < 768 && searchDrawer) {
      searchDrawer.classList.add('hidden');
    } else if (window.innerWidth >= 768) {
      searchInputWrapper.classList.remove('open');
      setTimeout(() => {
        searchInputWrapper.classList.add('hidden');
      }, 300); // Match the transition duration
      isSearchInputOpen = false;
    }
  });
}

// Close the search input when clicking outside on larger screens
document.addEventListener('click', function(event) {
  if (
    isSearchInputOpen &&
    window.innerWidth >= 768 &&
    !searchInputWrapper.contains(event.target) &&
    event.target !== toggleSearchDrawerBtn
  ) {
    searchInputWrapper.classList.remove('open');
    setTimeout(() => {
      searchInputWrapper.classList.add('hidden');
    }, 300); // Match the transition duration
    isSearchInputOpen = false;
  }
});


function addHideStyles() {
  let styleTag = document.querySelector('#hideStyles');
  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = 'hideStyles';
    document.head.appendChild(styleTag);
  }
  styleTag.innerHTML = `
        #stamped-widget-drawer .stamped-widget-button {
          margin-left: 0 !important;
        }
      `;
}

function removeHideStyles() {
  const styleTag = document.querySelector('#hideStyles');
  if (styleTag) {
    styleTag.innerHTML = '';
  }
}

function isAtSameYPosition(element1, element2) {
  if (!element1 || !element2) return false;
  const rect1 = element1.getBoundingClientRect();
  const rect2 = element2.getBoundingClientRect();

  return (rect1.top + 130) >= rect2.top;
}

function checkElementsPosition() {
  const element1 = document.querySelector('#stamped-widget-drawer');
  const element2 = document.querySelector('#ContactFooter');

  if (isAtSameYPosition(element1, element2)) {
    addHideStyles();
  } else {
    removeHideStyles();
  }
}

window.addEventListener('scroll', checkElementsPosition);

// Initial check
checkElementsPosition();

// Add class to body when on Customer Support page
if (window.location.href.indexOf("customer-support") > -1) {
    document.body.classList.add("customer-support-page");
}
